<template>
  <client-only>
    <div class="flex justify-center m-auto w-full px-[3vw] md:px-6">
      <div v-if="computedPageAncestors?.length" class="w-full app-max-width m-auto">
        <div class="flex gap-2 md:gap-3 items-center">
          <i
            class="fas fa-globe text-sm pr-2"
            :class="[
              ws.is_opened.value // .value is required, although it might show it as red
                ? 'text-blue-600/80'
                : 'text-gray-500'
            ]"
            />

          <template
            v-for="(crumb, i) in computedPageAncestors"
            :key="'breacrumb_'+crumb.to"
            >
            <ui-link
              :to="crumb.to"
              class="truncate text-sm md:text-base"
              :disabled="i === computedPageAncestors.length - 1"
              >
              <span
                v-if="crumb.text"
                v-text="t(dataBreadcrumbAdjustments[crumb.title]?.text ?? crumb.text)"
                />
            </ui-link>

            <!-- if not is last insert chevron right -->
            <i
              v-if="(i < computedPageAncestors.length - 1) || dataBreadcrumbAdjustments['fakelast']"
              class="fas fa-chevron-right text-[8px] text-sky-900"
              />

            <span v-if="(i >= computedPageAncestors.length - 1) && dataBreadcrumbAdjustments['fakelast']">
              <span
                v-text="t(dataBreadcrumbAdjustments['fakelast']?.text ?? dataBreadcrumbAdjustments['fakelast']?.text)"
                />
            </span>

          </template>
        </div>
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
const route = useRoute()
const router = useRouter()

const { locale, t } = useI18n({
  messages: {
    en: {
      'Setup': 'Setup',
      'Checkout': 'Checkout',
      'Profile': 'Profile',
    },
    de: {
      'Setup': 'Einrichtung',
      'Checkout': 'Kasse',
      'Profile': 'Profil',
    },
    es: {
      'Setup': 'Configuración',
      'Checkout': 'Pago',
      'Profile': 'Perfil',
    },
    uk: {
      'Setup': 'Налаштування',
      'Checkout': 'Каса',
      'Profile': 'Профіль',
    },
  } as any
})

const computedPageAncestors = computed(() => {
  let split: any = route.path.split('/')

  const resolvedsplit = split.map((path: any, index: number) => {
    let p = split.slice(0, index + 1).join('/')

    // if first char is / truncate it
    if (p[0] === '/') {
      p = p.slice(1)
    }

    const resolved = router.resolve(`/${p}`);
    let name: any = (resolved.name as string)
      .split('__')[0]
      .split('-')

    // name is last item of list
    name = name[name.length - 1]

    // split name by capital letters
    name = name.replace(/([A-Z])/g, ' $1')

    // Remove whitespaces
    name = name.trim()

    // replace first letter with uppercase
    name = name.charAt(0).toUpperCase() + name.slice(1)

    return {
      text: name,
      to: resolved.path,
      title: resolved.name
    }
  }) as any

  // omit first
  split = Object.assign([], resolvedsplit)
  split.shift()

  split = split.filter((path: any) => {
    return path.text.toLowerCase() !== 'slug' && path.text.toLowerCase() !== 'index'
  })

  if(split?.length <= 0){
    return resolvedsplit.map((x: any) => {
      x.text = x?.to?.split('/')?.pop();

      // to pascal case
      x.text = x.text.charAt(0).toUpperCase() + x.text.slice(1)

      // split at uppercases
      x.text = x.text.replace(/([A-Z])/g, ' $1')

      return x
    }).filter((x: any) => {
      // Filter empties and locales
      return x.text && ((x.text + '')?.toLowerCase() == locale.value)
    })
  }

  // filter out where is "Hidden"
  split = split.filter((x: any) => {
    return x.text.toLowerCase() !== 'hidden'
  })

  // filter out entries where title appears more than once, get rid of the latter
  split = split.filter((x: any, i: number) => {
    return split.findIndex((y: any) => y.title === x.title) === i
  })

  return split;
})
</script>
